import { FC } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Image, Modal, TextLink } from 'baby-design'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Product } from '../../../RegItemCard.types'

import css from './MobileBuyingSheet.styles.scss'

interface MobileBuyingSheetProps {
  product: Product
}

const MobileBuyingSheet: FC<MobileBuyingSheetProps> = ({ product }) => {
  const modal = useModal()

  return (
    <Modal showCloseButton handleClose={modal.hide} isOpen={modal.visible}>
      <div className={css.MobileBuyingSheet}>
        <div className={css.MobileBuyingSheet__productInfo}>
          {product.image && (
            <Image
              alt={product.heading}
              className={css.MobileBuyingSheet__image}
              height={80}
              src={product.image}
              width={80}
            />
          )}
          <div className={css.MobileBuyingSheet__titleAndLink}>
            <h2 className={css.MobileBuyingSheet__title}>{product.heading}</h2>
            <TextLink underline href={product.url} size="xs">
              View details
            </TextLink>
          </div>
        </div>
        <p>Buying options go here...</p>
      </div>
    </Modal>
  )
}

export default NiceModal.create(MobileBuyingSheet)
